module.exports = __webpack_public_path__ + "img/coding_cookies.deba974a.jpeg";